import React, { ReactNode } from "react";

import { Group, Anchor, Button } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { OnboardingTour } from "@gfazioli/mantine-onboarding-tour";

interface ReusableOnboardingTourProps {
  focusRevealProps?: any;
  tour: any[];
  started: boolean;
  onOnboardingTourEnd: () => void;
  maw?: number;
  __size?: "xs" | "sm" | "md" | "lg" | "xl";
  children?: ReactNode;
}

export const ReusableOnboardingTour: React.FC<ReusableOnboardingTourProps> = ({
  focusRevealProps,
  tour,
  started,
  onOnboardingTourEnd,
  maw = 300,
  __size = "xs",
  children,
}) => {
  const { t } = useTranslation();

  return (
    <OnboardingTour
      focusRevealProps={focusRevealProps}
      tour={tour}
      started={started}
      onOnboardingTourEnd={onOnboardingTourEnd}
      maw={maw}
      __size={__size}
      withStepper
      withSkipButton={false}
      withPrevButton={false}
      withNextButton={false}
      footer={(controller) => (
        <Group justify="space-between" gap="xs">
          {controller.currentStepIndex !== tour.length - 1 ? (
            <Anchor
              component="button"
              type="button"
              size="xs"
              underline="hover"
              onClick={() => controller.endTour()}
            >
              {t("skip")}
            </Anchor>
          ) : (
            <div />
          )}

          <Group gap="xs">
            {controller.currentStepIndex !== 0 && (
              <Button
                variant="light"
                size="xs"
                onClick={() => controller.prevStep()}
              >
                {t("previous")}
              </Button>
            )}
            <Button
              variant="light"
              size="xs"
              onClick={() =>
                controller.currentStepIndex === tour.length - 1
                  ? controller.endTour()
                  : controller.nextStep()
              }
            >
              {controller.currentStepIndex === tour.length - 1
                ? t("end")
                : t("next")}
            </Button>
          </Group>
        </Group>
      )}
    >
      {children}
    </OnboardingTour>
  );
};
